import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm } from "availity-reactstrap-validation";
import ReactSelect from "react-select";

const StatusModal = props => {
  const {
    isOpen,
    toggle,
    currentStatus,
    historyData,
    updateOfferStatus,
    offerId,
    permissions,
  } = props;

  const [status, setStatus] = React.useState();

  let state = {
    isFormSubmit: false,
  };

  const STATUSES = [
    { label: "Active", value: 1 },
    // { label: "Rent", value: 2 },
    { label: "Archived", value: 0 },
    { label: "Not active", value: -1 },
  ];

  React.useEffect(() => {
    if (isOpen) {
      setStatus(STATUSES[STATUSES.findIndex(i => i.value == currentStatus)]);
    }
  }, [isOpen]);

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    let ids = [];
    const data = {
      status: status.value,
    };

    historyData.map(i => {
      ids.push(i.id);
    });

    updateOfferStatus(offerId, ids, data);
    return toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      autoFocus={true}
      centered={true}
      toggle={toggle}
    >
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            Edit offer status
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label htmlFor="offer">Status</Label>
                <FormGroup>
                  <ReactSelect
                    name="groups"
                    options={STATUSES}
                    onChange={setStatus}
                    defaultValue={status}
                    placeholder="Select status..."
                    isSearchable={true}
                    classNamePrefix="select2-selection"
                    isFormSubmit={state.isFormSubmit}
                    isRequired
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_appoffermodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

StatusModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  currentStatus: PropTypes.number,
  updateOfferStatus: PropTypes.func.isRequired,
  historyData: PropTypes.array,
  offerId: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
};

export default StatusModal;
